import { render, staticRenderFns } from "./UIRangeSlider.vue?vue&type=template&id=a3f56fac&scoped=true"
import script from "./UIRangeSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./UIRangeSlider.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UIRangeSlider.vue?vue&type=style&index=0&id=a3f56fac&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f56fac",
  null
  
)

export default component.exports